import React, { Fragment } from "react";
import InputCard from "../../common/InputCard";

class CardsLayout extends React.Component {
  state = {};
  constructor() {
    super();
    this.cardsLayout = [
      // cards
      {
        title: "card1",
        hideTitle: true,
        items: [
          {
            label: {
              value: ""
            },
            span: {
              value: "Order Supply Info",
              alignment: "flex-end",
              size: "100%"
            },

            item: {
              node: "onlySpan",
              value: "",
              intemName: Math.random()
            },
            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: "Go Strat",
              size: "calc(100% - 58px)"
            },
            item: {
              node: "input",
              type: "string",
              onBlur: "checkOrderConstraints",
              value: "",
              intemName: "target"
            },
            size: "25%"
          },
          {
            label: {
              value: "Min Gate",
              size: "calc(100% - 58px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              onBlur: "checkOrderConstraints",
              intemName: "minDays"
            },
            size: "25%"
          },
          {
            label: {
              value: "CGo Strat",
              size: "calc(100% - 58px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "actual"
            },
            size: "25%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Allocation Control Flags",
              alignment: "flex-end",
              size: "100%"
            },

            item: {
              node: "onlySpan",
              value: "",
              intemName: Math.random()
            },

            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: "EOQ Days",
              size: "calc(100% - 58px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "eoqDays"
            },
            size: "25%"
          },
          {
            label: {
              value: "Usage Control",
              size: "calc(100% - 58px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^aAiI]",
              forceCaps: true,
              maxLength: 1,
              intemName: "usageCl"
            },
            size: "25%"
          },
          {
            label: {
              value: "EOQ Logic",
              size: "calc(100% - 58px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^aA ]",
              forceCaps: true,
              maxLength: 1,
              intemName: "eoqFlag"
            },
            size: "25%"
          },
          {
            label: {
              value: "Service Used",
              size: "calc(100% - 58px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "srvUsed",
              filter: "[^gGtTmM]",
              forceCaps: true,
              maxLength: 1
            },
            size: "25%"
          },
          {
            label: {
              value: "Service Type",
              size: "calc(100% - 58px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^dDuU]",
              forceCaps: true,
              maxLength: 1,
              intemName: "srvType"
            },
            size: "25%"
          },
          {
            label: {
              value: "Solve Search",
              size: "calc(100% - 58px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^hHlL]",
              forceCaps: true,
              maxLength: 1,
              intemName: "solveSe"
            },
            size: "25%"
          },
          {
            label: {
              value: "Pallet Rounding",
              size: "calc(100% - 58px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^yYnNvV]",
              forceCaps: true,
              maxLength: 1,
              intemName: "plltRou"
            },
            size: "25%"
          },
          {
            label: {
              value: "Multi-Truck",
              size: "calc(100% - 58px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^YyNn]",
              forceCaps: true,
              maxLength: 1,
              intemName: "mTruck"
            },
            size: "25%"
          },
          {
            label: {
              value: "Truck Load Flag",
              size: "calc(100% - 58px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^bBcCeEfFoOpPrR]",
              forceCaps: true,
              maxLength: 1,
              intemName: "tLoadFg"
            },
            size: "25%"
          },
          {
            label: {
              value: "Order Force Flag",
              size: "calc(100% - 58px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^bBgGnNsStT]",
              forceCaps: true,
              maxLength: 1,
              intemName: "oForcFg"
            },
            size: "25%"
          },
          {
            label: {
              value: "Auto Order Flag",
              size: "calc(100% - 58px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^nNyY]",
              forceCaps: true,
              maxLength: 1,
              intemName: "autoFlg"
            },
            size: "25%"
          }
        ]
      },
      {
        title: "Order Constraints",
        items: [
          {
            label: {
              value: ""
            },
            span: {
              value: "Type",
              alignment: "flex-end",
              // alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "tag3"
            },
            size: "30%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Minimum Amt",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "tag4"
            },
            size: "20%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "% Total",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "tag5"
            },
            size: "15%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Maximum Amt",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "tag6"
            },
            size: "20%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "% Total",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "tag7"
            },
            size: "15%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Constraint 1",
              alignment: "flex-end",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "tag8"
            },
            size: "20%"
          },
          {
            label: {},
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "type01",
              noLabel: true
            },
            size: "10%"
          },
          {
            label: {},
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^0-9]",
              maxNumber: "999999",
              onBlur: "checkOrderConstraints",
              intemName: "mnAmt01",
              noLabel: true
            },
            size: "20%"
          },
          {
            label: {},
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^0-9]",
              maxNumber: "99",
              intemName: "nPctL01",
              noLabel: true
            },
            size: "15%"
          },
          {
            label: {},
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^0-9]",
              maxNumber: "999999",
              onBlur: "checkOrderConstraints",
              intemName: "mxAmt01",
              noLabel: true
            },
            size: "20%"
          },
          {
            label: {},
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^0-9]",
              maxNumber: "99",
              onBlur: "checkOrderConstraints",
              intemName: "xPctL01",
              noLabel: true
            },
            size: "15%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Constraint 2",
              alignment: "flex-end",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "tag9"
            },
            size: "20%"
          },
          {
            label: {},
            item: {
              node: "input",
              type: "string",
              value: "",
              onBlur: "checkOrderConstraints",
              intemName: "type02",
              noLabel: true
            },
            size: "10%"
          },
          {
            label: {},
            item: {
              node: "input",
              type: "string",
              value: "",
              onBlur: "checkOrderConstraints",
              intemName: "mnAmt02",
              filter: "[^0-9]",
              maxNumber: "999999",
              noLabel: true
            },
            size: "20%"
          },
          {
            label: {},
            item: {
              node: "input",
              type: "string",
              value: "",
              onBlur: "checkOrderConstraints",
              intemName: "nPctL02",
              filter: "[^0-9]",
              maxNumber: "99",
              noLabel: true
            },
            size: "15%"
          },
          {
            label: {},
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^0-9]",
              onBlur: "checkOrderConstraints",
              maxNumber: "999999",
              intemName: "mxAmt02",
              noLabel: true
            },
            size: "20%"
          },
          {
            label: {},
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^0-9]",
              maxNumber: "99",
              onBlur: "checkOrderConstraints",
              intemName: "xPctL02",
              noLabel: true
            },
            size: "15%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Constraint 3",
              alignment: "flex-end",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "tag10"
            },
            size: "20%"
          },
          {
            label: {},
            item: {
              node: "input",
              type: "string",
              value: "",
              onBlur: "checkOrderConstraints",
              intemName: "type03",
              noLabel: true
            },
            size: "10%"
          },
          {
            label: {},
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^0-9]",
              maxNumber: "999999",
              onBlur: "checkOrderConstraints",
              intemName: "mnAmt03",
              noLabel: true
            },
            size: "20%"
          },
          {
            label: {},
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^0-9]",
              maxNumber: "99",
              onBlur: "checkOrderConstraints",
              intemName: "nPctL03",
              noLabel: true
            },
            size: "15%"
          },
          {
            label: {},
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^0-9]",
              maxNumber: "999999",
              intemName: "mxAmt03",
              onBlur: "checkOrderConstraints",
              noLabel: true
            },
            size: "20%"
          },
          {
            label: {},
            item: {
              node: "input",
              type: "string",
              value: "",
              filter: "[^0-9]",
              maxNumber: "99",
              onBlur: "checkOrderConstraints",
              intemName: "xPctL03",
              noLabel: true
            },
            size: "15%"
          }
        ]
      },
      {
        title: "Recent Orders",
        items: [
          {
            label: {
              value: ""
            },
            span: {
              value: "Date",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "tag11"
            },
            size: "32.5%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Items",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "tag12"
            },
            size: "17.5%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Date",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "tag13"
            },
            size: "32.5%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Items",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "tag14"
            },
            size: "17.5%"
          },

          {
            label: {
              value: " . ",
              size: "65%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "rODate1"
            },
            readOnly: true,
            size: "50%"
          },
          {
            label: {
              value: " . ",
              size: "65%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "rODate6"
            },
            readOnly: true,
            size: "50%"
          },
          {
            label: {
              value: " . ",
              size: "65%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "rODate2"
            },
            readOnly: true,
            size: "50%"
          },
          {
            label: {
              value: " . ",
              size: "65%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "rODate7"
            },
            readOnly: true,
            size: "50%"
          },
          {
            label: {
              value: " . ",
              size: "65%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "rODate3"
            },
            readOnly: true,
            size: "50%"
          },
          {
            label: {
              value: " . ",
              size: "65%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "rODate8"
            },
            readOnly: true,
            size: "50%"
          },
          {
            label: {
              value: " . ",
              size: "65%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "rODate4"
            },
            readOnly: true,
            size: "50%"
          },
          {
            label: {
              value: " . ",
              size: "65%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "rODate9"
            },
            readOnly: true,
            size: "50%"
          },
          {
            label: {
              value: " . ",
              size: "65%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "rODate5"
            },
            readOnly: true,
            size: "50%"
          },
          {
            label: {
              value: " . ",
              size: "65%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "rODate10"
            },
            readOnly: true,
            size: "50%"
          }
        ]
      }
    ];
  }

  componentDidMount() {
    this.setState({ layout: this.cardsLayout });
  }

  formatData = props => {
    if (props) {
      this.cardsLayout.map((card, c) => {
        const inputName = Object.keys(props[c])[0];

        card.items.map((item, i) => {
          if (item.item.intemName === props[c][inputName][i].name) {
            item.item.value = props[c][inputName][i].value;
            item.item.obj = props[c][inputName][i].obj;
            item.item.checked = props[c][inputName][i].checked;
            item.item.span = props[c][inputName][i].span;
            item.label.value = props[c][inputName][i].label;
            item.item.injectedValue = props[c][inputName][i].injectedValue;
          }

          return null;
        });
        return null;
      });
    }
    return null;
  };
  getCardsInfo = (info, title) => {
    this.props.setCardsInfo({ [title]: info });
  };
  renderCards = () => {
    this.formatData(this.props.cardsData);

    return (
      <Fragment>
        <div style={{ flex: 1 }}>
          <div style={{ flex: 1, display: "flex" }}>
            <div style={{ flex: 1.5 }}>
              <InputCard
                jsonObj={this.cardsLayout[0]}
                setCardsInfo={this.getCardsInfo}
                functions={{
                  checkOrderConstraints: this.props.checkOrderConstraints
                }}
              />
              <InputCard
                jsonObj={this.cardsLayout[1]}
                setCardsInfo={this.getCardsInfo}
                functions={{
                  checkOrderConstraints: this.props.checkOrderConstraints
                }}
              />
            </div>

            <div style={{ flex: 1 }}>
              <InputCard
                jsonObj={this.cardsLayout[2]}
                setCardsInfo={this.getCardsInfo}
                functions={{
                  checkOrderConstraints: this.props.checkOrderConstraints
                }}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  render() {
    return (
      <Fragment>
        <div className="cards-container" style={{ display: "flex" }}>
          {this.renderCards()}
        </div>
      </Fragment>
    );
  }
}
export default CardsLayout;
